<div class="mobile-nav">
    <a [routerLink]="['implicit-signup']" class="default-call-to-action">{{ 'GENERAL.SIGNUP' | translate }}</a>
    <a [routerLink]="['implicit-login']">{{ 'GENERAL.LOGIN' | translate }}</a>
    <button type="button" (click)="toggleNavSection('content-menu')">
        {{ 'MENU.CONTENT' | translate }}
        <ca-icon name="arrow-down" size="s" class="dropdown-toggle-icon ms-2" [ngClass]="{ rotated: isSectionOpen('content-menu') }"></ca-icon>
    </button>
    <ul class="submenu" [hidden]="!isSectionOpen('content-menu')">
        <li>
            <a [routerLink]="['workflows']">{{ 'MENU.WORKFLOWS' | translate }}</a>
        </li>
        <li>
            <a [routerLink]="['modules']">{{ 'MENU.MODULES' | translate }}</a>
        </li>
        <li>
            <a [href]="landingPageUrl + 'challenges'">{{ 'MENU.CHALLENGES' | translate }}</a>
        </li>
    </ul>
    <button type="button" (click)="toggleNavSection('resource-menu')">
        {{ 'MENU.RESOURCES' | translate }}
        <ca-icon name="arrow-down" size="s" class="dropdown-toggle-icon ms-2" [ngClass]="{ rotated: isSectionOpen('resource-menu') }"></ca-icon>
    </button>
    <ul class="submenu" [hidden]="!isSectionOpen('resource-menu')">
        <li>
            <a [href]="landingPageUrl + 'career-page/join-us-on-apeer'">{{ 'MENU.CAREER' | translate }}</a>
        </li>
        <li>
            <a [href]="landingPageUrl + 'pricing'">{{ 'MENU.PRICING' | translate }}</a>
        </li>
        <li><a target="_blank" rel="noopener" href="https://github.com/apeer-micro">Github</a></li>
        <li><a target="_blank" rel="noopener" href="https://www.youtube.com/channel/UCVrG0AsRMb0pPcxzX75SusA">YouTube</a></li>
        <li><a target="_blank" rel="noopener" href="https://twitter.com/apeer_micro?lang=de">Twitter</a></li>
        <li><a target="_blank" rel="noopener" href="https://github.com/apeer-micro/apeer-module-debugger/releases/tag/v1.1.0">Module debugger</a></li>
    </ul>
    <a href="https://docs.apeer.com/" target="_blank" rel="noopener" class="nav-item">{{ 'MENU.WIKI' | translate }}</a>
    <a href="/blog" target="_blank" class="nav-item">{{ 'MENU.BLOG' | translate }}</a>
</div>
